import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './_productChooser.css'
import ProductItem from './ProductItem'
import { Row, Col } from 'react-flexbox-grid'

export default class ProductChooser extends Component {

  static propTypes = {
    products: PropTypes.array,
    onSelect: PropTypes.func,
    defaultIndex: PropTypes.number,
  };

  state = {
    activeItem: null,
    currentProduct: null,
    defaultIndex: 0,
  };

  componentDidMount () {
    const { defaultIndex } = this.props
    this.handleSelectProduct(defaultIndex)()
  }

  handleSelectProduct = (index) => () => {
    const product = this.props.products[index]
    this.setState({
      activeItem: index,
      currentProduct: product,
    }, () => {
      this.props.onSelect(product)
    })
  }

  render () {
    const { products } = this.props

    products.sort((a, b) => {
      const aPrice = a.availability_details[0].price_point.amount
      const bPrice = b.availability_details[0].price_point.amount
      return aPrice - bPrice
    })

    return (
      <div className={styles.container}>
        <Row>
          {products.map((p, i) => (
            <Col xs={6} sm={5} key={i}>
              <ProductItem
                className={styles.item}
                onClick={this.handleSelectProduct(i)}
                active={this.state.activeItem === i}
                frequency={p.subscription_details.frequency_unit}
                price={p.availability_details[0].price_point.display_price}
              />
            </Col>
          ))}
        </Row>
      </div>
    )
  }

}
